import { Base } from './base';

export class PortalOperator extends Base {
    PortalOperatorID?: string;
    AuthorID?: string;
    CompanyID?: number;
    PublicInstitutionID?: number;
    FirstName?: string;
    LastName?: string;
    Phone?: string;
    Email?: string;
    Password?: string;
    CreateDate?: Date;
    SessionID?: string;
    LastIPAddress?: string;
    LastLogin?: Date;
    IsActive?: boolean;
    ValidationCode?: string;
    ValidationDate?: Date;
    Avatar?: string;
    LastUpdate?: Date;
    Birthday?: Date;
    Memo?: string;

    // Model properties
    Address?: string;
    FullName?: string;
    Plates?: Array<string>;
    RoleID?: number;
}
